import {
  setDataCollectionBrandsList,
  setIsSuccess,
  setResWorkflowName,
} from "../../../features/dataCollectionBrandsSlice";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import { dataCollectionBrandsServices } from "../../../services/api/data-collection-brands.endpoints";
import store from "../../../store";
import { mergeBrandData } from "../../../utils/mergedBrandData";

async function getAllBrands(
  oauthTokenHeader: any,
  biz_layer_query_id: any,
  raw_table_query_id: any,
  website_shared_uid: any,
  dispatch: any,
  setIsLoading: any
) {
  try {
    setIsLoading(true);

    // Fetch both brand metadata and raw table metadata
    const [brandResponse, rawTableResponse] = await Promise.all([
      dataCollectionBrandsServices.getAllBrandsList(
        oauthTokenHeader,
        biz_layer_query_id,
        website_shared_uid
      ),
      dataCollectionBrandsServices.getAllBrandsList(
        oauthTokenHeader,
        raw_table_query_id,
        website_shared_uid
      ),
    ]);

    if (brandResponse.status !== 200 || rawTableResponse.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while fetching brands",
          type: "error",
        })
      );
      return;
    }

    // Process the responses
    const mergedData = mergeBrandData(
      brandResponse?.data?.data?.query_output,
      rawTableResponse?.data?.data?.query_output
    );
    dispatch(setDataCollectionBrandsList(mergedData));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  } finally {
    dispatch(setIsLoading(false));
  }
}
async function brandsRunProcess(oauthTokenHeader: string, data: any) {
  try {
    const response = await dataCollectionBrandsServices.brandsRunProcess(
      oauthTokenHeader,
      data
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(setIsSuccess(false));
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while running brand process",
          type: "error",
        })
      );
    } else {
      store.dispatch(setIsSuccess(true));
      const workflowName = response?.data?.data?.workflow_name;
      if (workflowName) {
        store.dispatch(setResWorkflowName(workflowName));
      } else {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Workflow name not found in the response",
            type: "error",
          })
        );
      }
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}
export const dataCollectionBrandsEndPointLogic = {
  getAllBrands,
  brandsRunProcess,
};
